import twLocale from 'element-ui/lib/locale/lang/zh-TW' //引入element語言包
export default {
	all:{
		jiantizhongwen:'簡體中文',
		fantizhongwen:'繁體中文',
		yingwen:'英文',
		ribenyu:'日文',
		hanguoyu:'韓文',
		jizhuzhanghao:'記住帳號',
		jizhumima:'記住密碼',
		yuyanxuanze:'語言選擇',
		shezhi:'設置',
		xiugaimima:'修改密碼',
		yinsizhengce:'私隱政策',
		guanyuwomen:'關於我們',
		mimashuoming:'密碼必須是8-20位大小寫字母和數字組合，不能是純數字或純字母',
		qingshurujiumima:'請輸入舊密碼',
		qingshuruxinmima:'請輸入新密碼',
		quedingxiugai:'確定修改',
		
		shouye:'首頁',
		zhibo:'直播',
		wode:'我的',
		xitongxiaoxi:'系統消息',
		wodedingdan:'我的訂單',
		bangzhufankui:'幫助反饋',
		xiugaiziliao:'修改資料',
		xiaofeimingxi:'消費明細',
		zhibojilu:'直播記錄',
		tijiao:'提交',
		caozuochenggong:'操作成功',
		tishi:'提示',
		quedingtuichudenglu:'確定退出登錄嗎？',
		queding:'確定',
		wentibangzhu:'問題幫助',
		woyaofankui:'我要反饋',
		fankuiwenti:'反饋問題',
		qingmiaoshuniyaofankuidewenti:'請描繪你要反饋的問題...',
		sousuo:'搜尋',
		sousuoniganxingqudeneirong:'搜尋你感興趣的內容',
		zhibojianbiaoti:'直播間標題',
		zhibojianbeijing:'直播間背景',
		xuanzebackground:'選擇背景',
		shangchuanbeijing:'上傳背景',
		yixuanze:'已選擇',
		qingxuanzebeijing:'請選擇背景',
		zhibojianbiaoqian:'直播間標籤',
		zhibojianhuazhi:'直播間畫質',
		geinidezhibojianqugemingziba:'給你的直播間取一個名字吧~',
		qingshurukaibomiyao:'請輸入開播秘鑰',
		kaishizhibo:'開始直播',
		shengyin:'聲音',
		liwutexiao:'禮物特效',
		gengduo:'更多',
	    gouwuche:'購物車',
		zaixianguanzhong:'在線觀眾',
		danmushuoming:'平台嚴禁未成年人充值打賞，嚴禁以陪玩等方式誘導打賞私下交易，嚴禁涉黃涉政、謾罵等內容，請注意財產安全，謹防網絡詐騙，理性消費。',
		tianjiaguanliyuan:'添加管理員',
		jinyan:'禁言',
		jiechuejinyan:'解除禁言',
		tichufangjian:'踢出房間',
		shangpinxiangqing:'商品詳情',
		lijijiagou:'立即加購',
		xuanzeguige:'選擇規格',
		quanbuliwu:'全部禮物',
		ge:'個',
		bi:'幣',
		guanliyuan:'管理員',
		kuaijieduanyu:'快捷短語',
		gonggao:'公告',
		xinzengkuaijieduanyu:'新增快捷短語',
		qingshuru:'請輸入',
		qingshuruzhengque:'請輸入正確的金額',
		shuru:'輸入',
		wangjimima:'忘記密碼',
		youxiangzhuce:'郵箱註冊',
		huoquyanzhengma:'獲取驗證碼',
		qingshuruningdeyouxiangzhanghao:'輸入您的郵箱賬號',
		qingshuruyanzhengma:'請輸入驗證碼',
		qingshurumima:'請輸入密碼',
		mimadenglu:'密碼登錄',
		woyiyuedubingtongyi:'我已閱讀並同意',
		yonghuxieyi:'使用者協議',
		yinsixieyi:'隱私協議',
		denglu:'登錄',
		chongxindenglu:'重新登陸',
		xiayibu:'下一步',
		haimeizhanghao:'還沒有帳號',
		quzhuce:'去註冊',
		yiyouzhanghao:'已有帳號',
		qudenglu:'去登錄',
		shezhijibenxinxi:'設置基本資訊',
		nichengtishi:'僅支持字母、數字和標點符號，最少6位，不能使用空格',
		shezhiyonghuming:'設置用戶名',
		yonghumingtishi:'用戶名為6-18位，大小寫字母或數字',
		shezhijiaoyimima:'設置交易密碼',
		jiaoyimimatishi:'交易密碼必须是6位數字組合',
		qingxuanze:'請選擇',
		yaoqingma:'邀請碼（選填）',
		qingshuruyaoqingma:'輸入邀請碼',
		shezhixinmima:'設置新密碼',
		xuanzeningdeguojia:'選擇您的國家',
		zhuce:'註冊',
		qingshuruyonghuming:'請輸入用戶名',
		gaoqinghuazhi:'高清畫質',
		biaoqinghuazhi:'標清畫質',
		chaoqinghuazhi:'超清畫質',
		putonghuazhi:'普通畫質',
		kaishizhibo:'開始直播',
		zengsong:'贈送',
		jinrulezhibojian:'進入直播間',
		shuodianshenmene:'說點什麼呢...',
		zanwushuju:'暫無數據',
		songgei:'送給',
		huifang:'回放',
		quedingtuichudengluma:'確定退出登錄嗎?',
		xunibi:'虛擬幣',
		quanbu:'全部',
		appxiazai:'APP下載',
		dingdanjine:'訂單金額',
		dingdanbianhao:'訂單編號',
		chuangjianshijian:'創建時間',
		zhubozanshilikai:'主播暫時離開',
		mashanghuilai:'馬上回來',
		guojianzhuoxiazai:'國際安卓下載',
		anzhuoxiazai:'安卓下載',
		guojipingguoxiazai:'國際蘋果下載',
		pingguoxiazai:'蘋果下載',
		weixiazai:'暫無下載',
		quanbushangpin:'全部商品',
		yiqiangguang:'已搶光',
		jiagou:'加購',
		shangpinxiangqing:'商品詳情',
		lijijiagou:'立即加購',
		yixuan:'已選',
		xuanzeguiige:'選擇規格',
		xuazeguige:'選擇規格',
		shangchuanzhong:'上傳中',
		shangchuanshibai:'上傳失敗',
		browserbu支持:'您的瀏覽器不支援媒體設備訪問',
		qingkaiqi:'請開啟攝像頭和麥克風權限',
		meiyoushebei:'未檢測到攝像頭或麥克風設備',
		shebeibeizhan:'設備被其他程式占用，請關閉後重試',
		quxianchengong:'獲取媒體權限失敗',
		shifouquedingjieshuzhibo:'是否確定關閉直播？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'請閱讀並同意用戶協議和隱私協議！',
		quedingqudengluma:'確定去登錄嗎？',
		duanyingyin:'短影音',
		fabuduanyingyin:'發佈短影音',
		zhibohuaxu:'直播花絮',
		qingshurubiaoti:'請輸入標題',
		shangchuanduanyingyin:'上傳短影音',
		zhibozhongxin:'直播中心',
		zongzichanguzhi:'總資產估值',
		liushuijilu:'流水記錄',
		chongbi:'充幣',
		tibi:'提幣',
		dashang:'打賞',
		riqi:'日期',
		leixing:'類型',
		miaoshu:'描述',
		jine:'金額',
		zhuangtai:'狀態',
		yiwancheng:'已完成',
		shenhezhong:'審核中',
		shenhejujue:'審核拒絕',
		kaishiriqi:'開始日期',
		jieshuriqi:'結束日期',
		wangluo:'網絡',
		dizhi:'地址',
		tibishuliang:'提幣數量',
		daozhangshisuan:'到帳試算',
		shouxufei:'手續費',
		meiridaozhang:'每日到帳',
		keyong:'可用',
		dongjie:'凍結',
		zuixiaotibishuliang:'最小提幣數量',
		shouxufeibilv:'手續費',
		meirishenyueddu:'每日剩餘額度',
		shenqingzhibo:'申請直播',
		shenqingjilu:'申請記錄',
		huifangjilu:'回放記錄',
		yikaifang:'已開放',
		guankanhuifang:'觀看回放',
		beisu:'倍數',
		zhiboriqi:'直播日期',
		shijianshiduan:'時間時段',
		shoujizhibo:'手機直播',
		zhibodaihuo:'直播帶貨',
		kaiqi:'開啟',
		guanbi:'關閉',
		beizhu:'備註',
		huodongzhuti:'活動主題、設備說明',
		shenqinghouliucheng:'申請後流程',
		shenqinghouliuchengdesc:'後台審核通過後，將郵件發送直播會鈴定直播地址。',
		daishenhe:'待審核',
		tijiaoshenqing:'提交申請',
		qingxuanzeriqi:'請選擇直播日期',
		qingxuanzeshijian:'請選擇時間時段',
		tijiaochenggong:'提交成功',
		nian:'年',
		yue:'月',
		tongshiduanbukezhongfu:'同時段不可重複',
		keshenqingshiduan:'可申請時段',
		querenShiduan:'確認時段',
		zhanghaoid:'帳號 ID',
		qingtianxie:'請填寫',
		zhou1:'一',
		zhou2:'二',
		zhou3:'三',
		zhou4:'四',
		zhou5:'五',
		zhou6:'六',
		zhou7:'日',
		shenqingyitijiao:'申請已提交',
		shenqingtijiaodesc:'直播管理員將審核直播間、時段和帶貨資料。',
		chakanshenheJilu:'查看審核記錄',
		shenqingriqi:'申請日期',
		zhiboshijianduan:'直播時間段',
		zhiboleixing:'直播類型',
		daihuo:'帶貨',
		yitongguo:'已通過',
		weitongguo:'未通過',
		xiangqing:'詳情',
		yuanyin:'原因',
		shenqingxiangqing:'申請詳情',
		shenheyuanyin:'審核原因',
		xutiaozheng:'需調整',
		shenheyuanyindesc:'該時段直播間已被占用，請重新選擇直播日期或時間段後再次提交。',
		wancheng:'完成',
		chulizhong:'處理中',
		daichuli:'待處理',
		houtaishenhe:'後台審核',
		chanshengmiyao:'產生金鑰',
		youjiankuaidi:'郵件通知',
		kechakan:'可查看',
		jinwanxinpinfuli:'今晚新品福利直播',
		chehuishenqing:'撤回申請',
		chongxinshenqing:'重新申請',
		zhibojinyao:'直播金鑰',
		zhibojian:'直播間',
		keyongshiduan:'可用時段',
		youxiao:'有效',
		tuiliudizhi:'推流地址',
		tuiliumamiyao:'推流碼/秘鑰',
		youjiantongzhidesc:'同直播間同時段不會重複生成金鑰。',
		yifasong:'已發送',
		fuzhiquanbu:'複製全部',
		fuzhichenggong:'複製成功',
		youjiantongzhi:'郵件通知',
		zhiboshenhetongguo:'直播審核通過',
		shoujianren:'收件人',
		youjianneirongdesc:'內容包含直播間、可用時段、推拉流地址、密鑰和開播前設置入口',
		youjianbianhao:'郵件編號',
		chongxinfasong:'重新發送',
		yinyuedaren:'音樂達人',
		wudaodaren:'舞蹈達人',
		yanzhi:'顏值',
		jichushezhi:'基礎設置',
		yishangchuan:'已上傳',
		zhiboshangpin:'直播商品',
		laiziyunimall:'來自 UNImall 商城控制',
		jian:'件',
		zhiboliucheng:'直播流程',
		liuchang:'流暢',
		gaoqing:'高清',
		chaoqing:'超清',
		languang:'藍光',
		tongguo:'通過',
		jinxingzhong:'進行中',
		daikaiqi:'待開啟',
		qianzhizuoye:'前置作業',
		qingshangchuan:'請上傳',
		shangpinxuhao:'商品序號',
		shangpinshoutu:'商品首圖',
		shangpinmingcheng:'商品名稱',
		shangchengkucun:'商城庫存',
		zhibokucun:'直播庫存',
		shangchengjiage:'商城價格',
		zhibojiage:'直播價格',
		caozuo:'操作',
		yichu:'移除',
		zhibojiansetting:'直播間設置',
		kaiqishengyin:'開啟聲音',
		guanbishengyin:'關閉聲音',
		kaiqidanmu:'開啟彈幕',
		guanbidanmu:'關閉彈幕',
		kaiqimeiyan:'開啟美顏',
		guanbimeiyan:'關閉美顏',
		kaiqimaikefeng:'開啟麥克風',
		guanbimaikefeng:'關閉麥克風',
		kaiqimaike:'開麥克風',
		guanbimaike:'關麥克風',
		gonggao:'公告',
		fenxianglianjie:'分享鏈接',
		xietongzhibo:'協同直播',
		yaoqingjinbo:'邀請助播',
		tongyikongzhi:'統一控制',
		tichuzhubozb:'踢出選中助播',
		zhuborenshushangxian:'助播人數上限',
		ren:'人',
		tongzhibojinyao:'同直播金鑰',
		zhuboquanxian:'助播權限',
		yunxufayan:'允許發言',
		yunxukamai:'允許開麥',
		yunxukashipin:'允許開視頻',
		yikaiqi:'已開啟',
		shengchengyaoqingjinyao:'生成邀請金鑰',
		xietongzhiborenshu:'協同直播人數',
		dangqianzhibo:'當前助播',
		kenenghaiyaoqing:'可能還邀請',
		weizhibo:'位助播',
		baocunshangxian:'保存上限',
		fenxiangyaoqing:'分享邀請',
		yaoqinglianjie:'邀請鏈接',
		fenxiangfangshi:'分享方式',
		fuzhilianjie:'複製鏈接',
		baocunerweima:'保存二維碼',
		fuzhiyaoqinglianjie:'複製邀請鏈接',
		zhubo:'助播',
		guanli:'管理',
		yijinru:'已進入',
		maikefeng:'麥克風',
		shexiangtou:'攝像頭',
		guanbishexiangtou:'關閉攝像頭',
		kaiqishexiangtou:'開啟攝像頭',
		guanbijingxiang:'關閉鏡像',
		kaiqijingxiang:'開啟鏡像',
		sheweizhuyemian:'設為主畫面',
		quxiaozhuyemian:'取消主畫面',
		tichuzhibo:'踢出直播間',
		tichuhoubukejinru:'踢出後不可再進入該直播間',
		tongyikongmai:'統一控麥',
		quanjukongzhi:'全局控制',
		quantijingyin:'全體靜音',
		yunxuzhubokaimai:'允許助播開麥',
		yunxuzhubokaishipin:'允許助播開視頻',
		huifukaimai:'恢復開麥',
		guanbishipin:'關閉視頻',
		yunxushipin:'允許視頻',
		yingyongshezhi:'應用設置',
		shipin:'視頻',
	kaimai:'開麥',
	weikaiqi:'未開啟',
	shipinkaiqi:'視頻開啟',
	shipinguanbi:'視頻關閉',
	bimai:'閉麥',
	yunxufayan:'允許發言',
	jinzhifayan:'禁止發言',
	zhuboxiwei:'助播席位',
		guankanzhibo:'觀看直播',
		goumai:'購買',
		goumaishangpin:'購買商品',
		yishouqing:'已售罄',
		qianggou:'搶購',
		dashang:'打賞',
		chakangg:'查看公告',
		quxiao:'取消',
		queren:'確認',
		wodequanbao:'我的錢包',
		jiangjie:'講解',
		jiangjiezhong:'講解中',
		kucun:'庫存',
		qrcodenotexist:'二維碼不存在',
		qrcodesaved:'二維碼保存成功',
		wodeqianbao:'我的錢包',
		lianshangbaobishibei:'鏈上包幣市幣',
		zonge:'總額',
		keyongshuliang:'可用數量',
		dongjieshuliang:'凍結數量',
		chakanliushui:'查看流水',
		chongzhitip:'充幣提示：僅支持同鏈網絡，區塊鏈確認到鏈轉帳資產無法找回',
		chongzhishuliang:'充值數量',
		yujidaozhang:'預計到帳',
		shijidaozhang:'實際到帳',
		lijichongzhi:'立即充值',
		chongzhierweima:'充值二維碼',
		chongbidizhi:'充幣地址',
		fuzhidizhi:'複製地址',
		chongzhichenggong:'充值成功',
		chongbichenggong:'充幣成功',
		bizhong:'幣種',
		shuliang:'數量',
		shijian:'時間',
		tibidizhi:'提幣地址',
		tibishisuan:'提幣試算',
		zuiditixianjin:'最低提現金額',
		meiriyushutixian:'每日剩餘提現金額',
		keyongyu:'可用餘額',
		tijiaotibi:'提交提幣',
		xuanzetibidizhi:'選擇提幣地址',
		sousuodizhi:'搜索地址',
		xuanze:'選擇',
		querentbi:'確認提幣',
		xuanzedashangbizhong:'選擇打賞幣種',
		yue:'餘額',
		dashangjine:'打賞金額',
		zhanshidashangxinxi:'展示打賞信息',
		zidingyi:'自定義',
		querendashang:'確認打賞',
		zaixianguanzhong:'在線觀眾',
		yizhibo:'已直播',
		jieshizhibo:'結束直播',
		zhibozhong:'直播中',
		zanwuzaixianguanzhong:'暫無在線觀眾',
		shangchuanshibai:'視頻上傳失敗，請稍後重試',
		qingshurucontent:'請填寫標題並上傳視頻',
		fabuchenggong:'發佈成功',
		fabushibai:'發佈失敗',
		qingshurushuju:'請輸入數據',
		confirmDelete:'確認刪除此影片？',
		shanchuchenggong:'刪除成功',
		confirmWithdraw:'確認撤回此影片？',
		chehuichenggong:'撤回成功',
		yongjiujinyan:'永久禁言',
		jiaruzhibo:'加入直播',
		jiaruxietongzhibo:'加入協同直播',
		tuichuxietongzhibo:'退出協同直播',
		zhubojinyao:'助播金鑰',
		qingshuruzhubojinyao:'請輸入助播金鑰',
		jiaru:'加入',
		shenqingchenggong:'申請成功',
		youxiaoqi:'有效期',
		tichubenchang:'踢出本場',
		zhanshidashangxiaoxi:'展示打賞消息',
		zanwugonggao:'暫無公告',
		dashang:'打賞',
		songgei:'送給',
		ge:'個',
		bi:'幣',
		zanweiyourenjiaruxietongzhibo:'暫未有人加入協同直播',
		zanweikaiqi:'暫未開啟協同直播'
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js